import {resource} from '@albert-io/json-api-framework/request/builder';
import masqueradeStore from 'generic/Masquerade/Masquerade.store';

interface CleverClassSuccessResult {
  success: true;
  classroom_id: string;
  classroom_name: string;
  status: 'created' | 'updated' | 'archived';
}

interface CleverClassErrorResult {
  success: false;
  message: string;
  classroom_name: string;
}

export type CleverClassResult = CleverClassSuccessResult | CleverClassErrorResult;

interface CleverSyncSuccessResults {
  success: true;
  results: CleverClassResult[];
}

interface CleverSyncErrorResults {
  success: false;
  message: string;
}

export type CleverSyncResults = CleverSyncSuccessResults | CleverSyncErrorResults;

export const getUserQuery = () => {
  return resource('user_v2')
    .mandarkEndpoint(['users_v2', masqueradeStore.getUserIdByMasqueradeState()])
    .withMeta('user_v2')
    .customQuery({
      meta: {
        context: {
          user: {
            last_clever_sync_date: true,
            allow_clever_sync: true,
            current_clever_sync_id: true
          }
        }
      }
    });
};
